import { makeStyles } from '@material-ui/core/styles'
import { grey } from "@material-ui/core/colors";
import { blue } from "@material-ui/core/colors";

const SideStyle = makeStyles(theme => ({
  test: {
    border: 'solid 1px red',
    padding: '0',
    margin: '0',
  },

  //TitleBar
  appBar: {
    backgroundColor: '#292D39', //grey[600],
    position: "relative",
    color: '#fff',
  },
  toolbar: {
    margin: '0',
    padding: '0 0 0 10px',
  },
  title: {
    flexGrow: 1,
    padding: '15px',
    marginLeft: '1rem',
  },
  type: {
    flexGrow: 1,
    backgroundColor: '#007BFF', //blue[800],
    padding: '5px',
    borderStyle: 'solid',
    borderWidth: '2px',
    borderColor: '#fff',
    textAlign: 'center',
  },
  debug: {
    flexGrow: 1,
    backgroundColor: '#007BFF', //blue[800],
    padding: '5px',
    borderStyle: 'solid',
    borderWidth: '2px',
    borderColor: '#fff',
    textAlign: 'center',
  },

  // https://github.com/mui/material-ui/issues/7602
  // https://stackoverflow.com/questions/50743402/material-ui-grid-item-height

  //ViewChanger
  buttonStretchHeight: {
    height: "100%"
  },

  //Workflow
  moduleTitle: {
    backgroundColor: grey[900],
    textAlign: 'center',
    color: '#fff',
    padding: '5px',
    marginTop: '10px',
  },
  workflow: {
    padding: '0 10px',
    width: '100%',
  },

  //Checkbox
  typo: {
    textAlign: 'center',
    color: '#fff',
    padding: '5px',
  },

  //Viewchanger
  viewchanger: {
    flexGrow: 1
  },

  //Form
  frame: {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#424242',
    padding: '0 10px',
  },
  center: {
    position: "relative",
    textAlign: 'center',
    padding: '5px 0',
    margin: '5px 0',
  },

  button2: {

    padding: '20',
    margin: '2px 0',
  },
  button: {
    color: '#fff!important',
    backgroundColor: '#757575!important', //grey[600]
    borderStyle: 'solid!important',
    borderWidth: '1px!important',
    borderColor: '#424242!important', //grey[800]
    width: '100%',
    height: '100%',
    '&:hover': {
      backgroundColor: '#9e9e9e!important', //grey[500]
    }
  },

  buttonImportant: {
    color: '#fff!important',
    backgroundColor: '#F75C4D!important', //grey[600]
    borderStyle: 'solid!important',
    borderWidth: '1px!important',
    borderColor: '#424242!important', //grey[800]
    width: '100%',
    height: '100%',
    '&:hover': {
      backgroundColor: '#FC877C!important', //grey[500]
    }
  },

  buttonView: {
    color: '#fff!important',
    backgroundColor: '#424242!important', //grey[600]
    borderStyle: 'solid!important',
    borderWidth: '1px!important',
    borderColor: '#202020!important', //grey[800]
    width: '100%',
    height: '100%',
    '&:hover': {
      backgroundColor: '#9e9e9e!important', //grey[500]
    }
  },

  buttonShowHide: {
    color: '#fff!important',
    padding: '5px 0',
    margin: '5px 0',
    backgroundColor: '#007BFF!important', //grey[600]
    borderStyle: 'solid!important',
    borderWidth: '1px!important',
    borderColor: '#424242!important', //grey[800]
    width: '30%',
    '&:hover': {
      backgroundColor: '#9e9e9e!important', //grey[500]
    }
  },
  buttonSelected: {
    backgroundColor: '#007BFF!important', //'#42a5f5!important', //blue[400]
    width: '100%',
    height: '100%',
  },
  buttonDisable: {
    backgroundColor: grey[600], //'#42a5f5!important', //blue[400]
    width: '100%',
    height: '100%',
  },

  outside: {
    backgroundColor: grey[700],
    padding: '10px',
    margin: '10px',
    color: '#fff',
  },
  outside2: {
    backgroundColor: grey[500],
    padding: '10px',
    margin: '0',
    width: '100%',
  },
  outside3: {
    backgroundColor: grey[300],
    padding: '10px',
    margin: '0',
    width: '100%',
  },
  subcategory: {
    backgroundColor: grey[800], //'#757575',
    padding: '5px 0',
    margin: '5px 0',
    width: '100%',
    textAlign: 'center',
  },
  assemble: {
    padding: '4px 0',
  },
  topBtns: {
    color: '#fff',
    border: '2px solid grey',
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  viewHead: {
    background: 'linear-gradient(90deg, rgba(136,139,129,0.5) 39%, rgb(41, 45, 57, 0.5) 51%, rgba(130,128,128,0.8827906162464986) 100%)',
    display: 'flex',
    justifyContent: 'center',
    padding: '0.5em',
    fontWeight: 'bold',
    fontSize: '0.9em',
    flex: 0.4
  },
  btnGrp: {
    display: 'flex',
    padding: '0.5em',
    gap: 2
  },
  perspectiveBtns: {
    display: 'flex',
    gap: 3,
    flex: 1,
    marginTop: '2.5%'
  },
  ppBtn: {
    padding: '0.3em',
    display: 'flex',
    flexDirection: 'column',
    flex: 0.6,
    gap: 2
  },
  pullBtn: {
    fontSize: 13,
    padding: 4
  }
}));

export default SideStyle;